import React from 'react';
import LinkAccount from '../components/LinkAccount.js';
import sidebarEPLogo from '../img/exampro-logo-white.svg';

export default class Sidebar extends React.Component {

    /**
       * Initializes the Sidebar component state.
       * @param {Object} props - React props.
       */
    constructor(props) {
        super(props);
        this.state = {
            showlink: false
        };
    }

    /**
   * Shows or hides the LinkAccount dialog.
   * @param {boolean} toggle - Whether to show (true) or hide (false) the dialog.
   */
    showLink = (toggle) => {
        this.setState({ showlink: toggle });
    };

    /**
   * Renders the sidebar UI, including navigation, settings, help, logout, and the LinkAccount dialog.
   * @returns {JSX.Element}
   */
    render() {

        return (
            <div>
                <div id="Sidebar" className={`sidebar ${this.props.showSidebar === true ? "sidebar-open" : "sidebar-close"}`}>
                    <button className="sidebar-toggle" onClick={() => this.props.sidebartoggle()}><i className="fas fa-bars"></i></button>
                    <img className="sidebar-logo" src={sidebarEPLogo} alt="brand-logo" />
                    <h2 className="sidebar-header">Student Portal</h2>
                    <div className="sidebar-name-container">
                        <p className="sidebar-name">{this.props.student.fullname}</p>
                    </div>
                    <div className="sidebar-selection">

                        {this.props.menuitems ?

                            this.props.menuitems.map(c =>

                                <div className='sidebar-button-container' key={c.sortorder} >
                                    <button className={`sidebar-item ${c.statusid === 0 ? 'active' : ''}`} data-selection={c.btntxt} data-filter={c.statusid} onClick={(e) => this.props.getSelection(e)} ><i className={"fas " + c.icon + " sidebar-icon"} />
                                        <span className="open-text">{c.btntxt}
                                            {/* <span className="record-count">{c.cnt}</span> */}
                                        </span>
                                        <span className="close-text">{c.btntxtshort}
                                            {/* <span className="record-count">{c.cnt}</span> */}
                                        </span>
                                    </button>
                                </div>


                            ) : null}

                        <div className='sidebar-button-container'>
                            <button className={`sidebar-item`} onClick={(e) => this.props.showSettings(e)} data-selection={"Settings"} data-filter={"Settings"}><i className={"fa fa-cog sidebar-icon"} />
                                Settings
                            </button>
                        </div>


                        <div className='sidebar-button-container'>
                            <a className="sidebar-item" href="https://stsupport.exampro.co.uk/kb/" target="_blank" rel="noreferrer"><i className="fas fa-question" />Help</a>
                        </div>
                        <div className='sidebar-button-container'>
                            <a className="sidebar-item" href="/logout.php"><i className="fa fa-power-off" />Logout</a>
                        </div>

                    </div>
                </div>

                {this.state.showlink ? <LinkAccount type="link" close={this.showLink} /> : null}

            </div>




        );
    }
}
